module.exports = __webpack_public_path__ + "img/certificate-en.67a24467.jpg";